module.exports = __webpack_public_path__ + "static/media/Pic-0526.878e52c5.jpg";